import { Boton, Centro, Grilla, GrillaEl, Imagen, PilaV } from '../../atomos';
import { Heading, ListItem, UnorderedList } from '@chakra-ui/react';
import { ChevronRight } from 'lucide-react';
import Persona404 from '@/assets/img/persona-404.webp';
import { anchoMaximo } from '@/styles/constants';
import { useNavigate } from 'react-router-dom';
import { CREDENCIALES } from '@/routes/AppRoutes';

const Pantalla404 = () => {
  const navigate = useNavigate();

  const enviarAlInicio = () => navigate(CREDENCIALES.INICIARSESION);

  return (
    <Centro>
      <Grilla templateColumns={'1fr 1fr'} h={'100dvh'} maxW={anchoMaximo}>
        <GrillaEl
          as={PilaV}
          alignItems={'start'}
          justifyContent={'center'}
          colSpan={1}
          p={5}
          spacing={3}
        >
          <PilaV alignItems={'start'} spacing={0}>
            <Heading color={'bPink.400'}>Oops!</Heading>
            <Heading fontWeight={'medium'} style={{ textWrap: 'balance' }}>
              No encontramos la pagina que estas buscando
            </Heading>
          </PilaV>

          <UnorderedList color={'foreground-secondary'}>
            <ListItem>La direccion introducida es incorrecta</ListItem>
            <ListItem>El link esta roto o caducado</ListItem>
          </UnorderedList>
          <Boton variant={'action'} size={'lg'} onClick={enviarAlInicio}>
            Volver al inicio <ChevronRight size={18} />
          </Boton>
        </GrillaEl>
        <GrillaEl colSpan={1} as={Centro}>
          <Imagen src={Persona404} alt='persona-404' />
        </GrillaEl>
      </Grilla>
    </Centro>
  );
};

export default Pantalla404;
